import { Component, OnInit } from '@angular/core';
import { ReferralService } from '../referral/referral.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-referral-toggle',
  templateUrl: './referral-toggle.component.html',
  styleUrls: ['./referral-toggle.component.scss']
})
export class ReferralToggleComponent implements OnInit {
  referralStatusCustomer: boolean = false;
  referralStatusPartner: boolean = false;
  isLoading: boolean = false;

  constructor(
    private referralService: ReferralService,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {
    this.loadReferralStatus();
  }

  loadReferralStatus(): void {
    this.isLoading = true;
    this.referralService.getReferralToggleStatus().subscribe({
      next: (response: any) => {
        console.log('Referral status loaded:', response);
        this.referralStatusCustomer = response.customer;
        this.referralStatusPartner = response.partner;
        this.isLoading = false;
      },
      error: (error) => {
        console.error('Error loading referral status:', error);
        this.toastr.error('Failed to load referral status');
        this.isLoading = false;
      }
    });
  }

  toggleReferral(type: 'customer' | 'partner'): void {
    const newStatus = type === 'customer' ? !this.referralStatusCustomer : !this.referralStatusPartner;
    this.isLoading = true;

    this.referralService.toggleReferralStatus(type, newStatus).subscribe({
      next: (response: any) => {
        console.log('Referral toggle response:', response);
        this.referralStatusCustomer = response.customer;
        this.referralStatusPartner = response.partner;
        this.toastr.success(`${type === 'customer' ? 'Customer' : 'Partner'} referral ${newStatus ? 'enabled' : 'disabled'} successfully`);
        this.isLoading = false;
      },
      error: (error) => {
        console.error('Error toggling referral status:', error);
        this.toastr.error('Failed to toggle referral status');
        this.isLoading = false;
      }
    });
  }
}